import {TopReelFeature} from "./TopReelFeature";
import {FeatureList, GameConfig} from "../../../../GameConfig";
import {gsap} from "gsap";
import {HOTB} from "../../../../HOTB";
import {SymbolsList} from "../../../../reels/GameSymbol";
import {AnimUtils} from "../../../../utils/AnimUtils";
import {GameSounds} from "../../../../sound/GameSounds";

export class LaunchFeature extends TopReelFeature {
    constructor(reelId: number) {
        super(reelId, FeatureList.LAUNCH);
    }

    public finishDrop(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add([
            super.finishDrop(),
            (): void => {
                AnimUtils.playScreenShake(GameConfig.itemDropShakePower);
                HOTB.soundPlayer.playSound(GameSounds.LAUNCH_LAND);
            }
        ]);

        tl.add((): void => {
            HOTB.reelArea.mainReelModels[this.reelId].reelView.transformSymbol(this.reelId, this.dropPosId, SymbolsList.LAUNCH);
        });

        // #312 delay used to avoid jerk issue
        tl.to(this, {
            duration: 0.01
        });

        return tl;
    }
}